import React from 'react'
import POSHealth from '../Components/Admin/POSHealth'

function POSHealthPage() {
    return (
        <>
            <POSHealth />
        </>
    )
}

export default POSHealthPage
